var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"format-set-directory-filter-root"},[_c('span',[_vm._v("フォルダ名称")]),_vm._v(" "),_c('string-filter',{attrs:{"shouldActiveIme":true},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }